import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { PageLayout, Places, PlacesList, Place } from 'pages'

export const PlaceRouter = () => {
  return (
    <Routes>
      <Route path="/*" element={<PageLayout showBackButton={true} />}>
        <Route path=":id/*" element={<Place />} />
        <Route path="map" element={<PlacesList />} />
        <Route index element={<Places />} />
      </Route>
    </Routes>
  )
}
